{
    "InsightsDashboard_Title": "Inzichten",
    "InsightsDashboard_BusinessFilter": "Bedrijfsfilter",
    "InsightsDashboard_AllPartitions": "Alle sites",
    "InsightsDashboard_CallsReceived": "Ontvangen oproepen",
    "InsightsDashboard_MissedCalls": "Gemiste oproepen",
    "InsightsDashboard_AverageAnswer": "Gemiddeld antwoord",
    "InsightsDashboard_AverageAbandoned": "Gemiddeld verlaten",
    "InsightsDashboard_LongestWait": "Langste wachttijd",
    "InsightsDashboard_VsLastWeekCurrently": "Momenteel",
    "InsightsDashboard_PercentVsLastWeek": "**{}%** versus vorige week",
    "InsightsDashboard_VsLastWeek": "**{}** vs. vorige week",
    "InsightsDashboard_BusiestDay": "Drukste dag",
    "InsightsDashboard_PeakCalls": "Piekgesprekken",
    "InsightsDashboard_MostCalledInboundNumber": "Meest gebelde inkomende nummers",
    "InsightsDashboard_MostAnsweredCalls": "Meest beantwoorde oproepen",
    "InsightDashboard_CalledNumber": "Gebeld nummer",
    "InsightsDashboard_User": "Gebruiker",
    "InsightsDashboard_SecondsDisplay": "{}S",
    "InsightsDashboard_Tooltip_TimeLabel": "Tijd: {}:00",
    "InsightsDashboard_Tooltip_DayLabel": "Dag: {}",
    "InsightsDashboard_Tooltip_CallsLabel": "Aantal oproepen: {}",
    "InsightsDashboard_Tooltip_Stats_0": "Ontvangen oproepen: {}",
    "InsightsDashboard_Tooltip_Stats_1": "Gemiste oproepen: {}",
    "InsightsDashboard_Tooltip_Stats_2": "Gemiddeld beantwoord: {}",
    "InsightsDashboard_Tooltip_Stats_3": "Gemiddeld verlaten: {}",
    "InsightsDashboard_Tooltip_Stats_4": "Langste wachttijd: {}",
    "InsightsDashboard_Tooltip_Stats_WeekCommencing": "Week beginnend: {}",
    "InsightsDashboard_OfLast30Days": "van de laatste 30 dagen",
    "InsightsDashboard_OverLast30Days": "De afgelopen 30 dagen",
    "InsightsDashboard_OverLast7Days": "De afgelopen 7 dagen",
    "InsightsDashboard_ThisWeek": "Deze week",
    "InsightsDashboard_LastWeek": "Vorige week",
    "InsightsDashboard_PrevWeek": "Vorige week",
    "InsightsDashboard_ErrorState_Message": "Het spijt ons dat er een probleem is opgetreden. \n Vernieuw uw browser. \n \n {}",
    "InsightsDashboard_ErrorState_No_TelSys_Or_Partition": "Geen telefonieserver of partitie geselecteerd",
    "InsightsDashboard_Tour_Step_1": "Hier selecteert u uw bedrijf en locatie",
    "InsightsDashboard_Tour_Step_2": "Bekijk contactpuntstatistieken over uw bedrijf over de afgelopen 30 dagen: \n ##?##Drukste dagen, zodat u resources beter kunt inplannen####Drukste tijden, zorg dat u klaarstaat met dekking op piektijden, zodat u geen oproepen mist####?",
    "InsightsDashboard_Tour_Step_3": "Belangrijkste prestatiegegevens voor oproepen in de afgelopen 30 dagen: \n ##?##Totaal aantal oproepen dat uw bedrijf heeft ontvangen####Gemiste oproepen####Gemiddelde antwoord- en verbreektijden####Langste wachttijd voor een oproep####? \n Klik op de gegevens voor een vergelijking van week tot week en trends.",
    "InsightsDashboard_Tour_Step_4": "Identificeer uw meest gebelde inkomende DDI's van de afgelopen 7 dagen, en welke gebruikers de meeste oproepen beantwoorden. Dit toont de top 10.",
    "InsightsDashboard_Tour_Step_5": "Klik hier om het rapportageportaal te openen",
    "InsightsDashboard_Tour_Step_6": "Klik hier om het rapportageportaal te openen",
    "NAME": "InsightsDashboardLanguage"
}